import { useEffect } from "react"; 
import { useSocketStore } from "../../stores/useSocketStore";
import { useSchedulesStore } from "../../stores/useSchedulesStore";

export function useSchedulesSocket() {

    const socket = useSocketStore(state => state.socket);

    useEffect(() => {
        
        if (!socket)
            return;

        const {
            setSchedule,
            removeSchedule
        } = useSchedulesStore.getState();

        socket.on('schedules:upserted', setSchedule);

        socket.on('schedules:deleted', removeSchedule);

        return () => {
            
            socket.off('schedules:upserted', setSchedule);

            socket.off('schedules:deleted', removeSchedule);

        };

    }, [socket]);

}